#import "../fragments/email-sequence-template-template-fragment.graphql"

query GetEmailSequenceTemplate($id: ID!) {
    emailSequenceTemplate(id: $id) {
        ...EmailSequenceTemplateTemplate
        isImmutable
        parent {
            ...EmailSequenceTemplateTemplate
            children {
                totalCount
                edges {
                    node {
                        ...EmailSequenceTemplateTemplate
                    }
                }
            }
        }
        userChildSequenceTemplate {
            ...EmailSequenceTemplateTemplate
        }
        children {
            totalCount
            edges {
                node {
                    ...EmailSequenceTemplateTemplate
                }
            }
        }
    }
}
